/*
 * *****************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Wed, Jul 21st 2021, 8:32:03 am
 *
 * *****************************************************
 */

import React from 'react';

import { Button } from '@shopify/polaris';
import {
  useGoogleLogin,
  GoogleLoginResponse,
  GoogleLoginResponseOffline
} from 'react-google-login';

import { Container, GoogleIcon } from './styles';

type GoogleButtonProps = {
  loading?: boolean;
  onSuccess: (res: GoogleLoginResponse | GoogleLoginResponseOffline) => void;
  onFailure: (error: any) => void;
};

/**
 * Button that triggers Google sign in.
 * onSuccess props received a param storing Google sign in result
 */
const GoogleButton = ({
  loading = false,
  onSuccess,
  onFailure
}: GoogleButtonProps): JSX.Element => {
  const { signIn: signInWithGoogle } = useGoogleLogin({
    clientId: process.env.REACT_APP_GOOGLE_SIGN_IN_CLIENT_ID as string,
    prompt: 'select_account',
    onSuccess,
    onFailure
  });
  return (
    <Container>
      <Button loading={loading} icon={<GoogleIcon />} onClick={signInWithGoogle}>
        Continue with Google
      </Button>
    </Container>
  );
};

export default React.memo(GoogleButton);
